<template>
  <div class="transition">
    <BasicText
      size="h5"
      class="titre-transition"
    >
      À quel IDCC, cette entité juridique est-elle rattachée ?
    </BasicText>
    <div class="transition-items flex flex-column flex-gap-8">
      <section>
        <WrapperAutocomplete
          label="IDCC de rattachement"
          placeholder="Code IDCC ou libellé"
          v-model="idcc"
          :search
          key-id="code"
          key-label="intitule"
          :get-input-text="getLibelle"
          :get-item-label="getLibelle"
          :search-min-length="2"
          strict
        />
        <BasicAlert
          alert-type="info"
          alert-label="Saisir le code de la convention collective (IDCC) de l'entreprise ou l'établissement du rattachement."
        />
      </section>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue'
  import type { CarteEvents, CarteProps } from '@/features/interface/machine-etats/types'
  import type { DemandeRattachementResult } from '../types'
  import type { IdccChampsDTO } from '@/features/api/extranet/dto/Rattachements'
  import * as services from '@/features/services/profil/RattachementInscriptionService'
  import { isNotNullUndefinedOrEmptyString } from '@/features/shared/tools'

  const props = defineProps<CarteProps<string, Pick<DemandeRattachementResult, 'idcc'>>>()
  const emits = defineEmits<CarteEvents<Pick<DemandeRattachementResult, 'idcc'>>>()

  const getLibelle = (idcc: IdccChampsDTO) => `${idcc.code} - ${idcc.intitule}`

  const idcc = computed<IdccChampsDTO | undefined>({
    get: () => props.out?.idcc,
    set: (value) => {
      emits('outChanged', isNotNullUndefinedOrEmptyString(value?.code), { idcc: value })
    },
  })

  const search = (query: string): Promise<IdccChampsDTO[]> =>
    services.searchIdccPerimetre(query, props.in, { sablier: false, dialogMode: 'silent' })
</script>

<style lang="less" scoped>
  .transition-items {
    margin: 36px 0;
    .alert {
      margin-top: 8px;
    }
  }
</style>
